import React from 'react';
import {isWebpSupported} from 'react-image-webp/dist/utils';

import explainer from '../../images/articles/explainer.png';
import explainer_webp from '../../images/articles/explainer.webp';
import commercial from '../../images/articles/commercial.png';
import commercial_webp from '../../images/articles/commercial.webp';
import product from '../../images/articles/product.png';
import product_webp from '../../images/articles/product.webp';
import software from '../../images/articles/software.png';
import software_webp from '../../images/articles/software.webp';
import social from '../../images/articles/social.png';
import social_webp from '../../images/articles/social.webp';

import TinySlider from "tiny-slider-react";


import {
    Link
  } from "react-router-dom";

const settings = {
    nav: false,
    controls:false,
    navPosition:'bottom',
    mouseDrag: true,
    items: 4,
    gutter: 20,
    edgePadding: 0,
    responsive: {
        100: {
            items: 1,
            gutter: 20,
            edgePadding: 60,
        },
        1000:{
            items: 4,
            gutter: 20,
            edgePadding: 0,
        }
    },
    autoplay:false,
    autoplayButtonOutput:false,
    speed:500
  };

  const services = [
    {
        title:'Explainer video',
        description:'Explainer video is a basic video marketing tool that you can use to explain your business ideas, services and products in a clear and entertaining way. Explainer videos vividly demonstrate your product-solution tackling the main pain-points faced by your consumers. They have an informational and educating element which also ensures an authentic connection with your target audience.',
        image:explainer,
        image_webp:explainer_webp,
        link : "/explainer-videos"
    },
    {
        title:'Commercial video',
        description:'Commercial videos are the traditional forms of video promotions to market a particular product or service focusing on their offerings and benefits. They are designed and targeted to push consumers further along their buying circle and trigger them to seriously consider a purchase. Thanks to their selling nature commercial videos tend to have the shortest length among all of the advertising video types.',
        image:commercial,
        image_webp:commercial_webp,
        link : "/commercial-videos"
    },
    {
        title:'Product video',
        description:'As the name clearly implies these types of videos are about “the product”- be it a tangible or intangible one. The product video brings your product into life showcasing how it functions in the real world. You kind of create a visual where the customers imagine what it would be like to use your product. Product videos demonstrate the benefits of the product and the problems it can solve to improve your customers’ lives for the better. This is a great marketing tool, which can break down complex ideas and information about your product quickly and succinctly.',
        image:product,
        image_webp:product_webp,
        link: "/product-videos"
    },
    {
        title:'Software Feauture video',
        description:'Software feature videos are one of the best ways to give a guided and detailed representation of your software, its new features, how they look and work. They provide a detailed description of a product-solution, that helps to solve users’ problems. Software companies use this kind of video to showcase their product from all different angles, demonstrate their full potential and make it understandable for their target audience. They are memorable and informative tools that trigger users to make a deal or stand closer to the deal.',
        image:software,
        image_webp:software_webp,
        link : "/software-feauture-videos"
    }
    ,
    {
        title:'Social Media<br>video',
        description:'Social media marketing videos have become an essential part of any marketing strategy regardless of the business industry. They are targeted and designed to be shared in social networks both for mobile and web viewing. Depending on your business goals social media videos can serve a number of purposes: to create awareness, to educate the audience, to explain a concept, as a call-to-action, etc. Users just love watching video on social media, no surprise why it’s known as the king of social media. Social media platforms also priortize native video content, which gradually makes video the best communication channel to interact with users.',
        image:social,
        image_webp:social_webp,
        link : "/social-media-videos"
    }
    ]

class ArticlesSlider extends React.PureComponent{

    constructor(props){

        super(props);

        this.onGoTo = this.onGoTo.bind(this);
    }

    componentDidMount(){
        document.querySelector('.tns-ovh').addEventListener('touchstart', this.touchStart);
        document.querySelector('.tns-ovh').addEventListener('touchmove', this.preventTouch, {passive: false});
    }
    
    componentWillUnmount(){
        document.querySelector('.tns-ovh').removeEventListener('touchstart', this.touchStart);
        document.querySelector('.tns-ovh').removeEventListener('touchmove', this.preventTouch, {passive: false});
    }
    touchStart(e){
        this.firstClientX = e.touches[0].clientX;
        this.firstClientY = e.touches[0].clientY;
    }
    
    preventTouch(e){
        const minValue = 5; // threshold
    
        this.clientX = e.touches[0].clientX - this.firstClientX;
        this.clientY = e.touches[0].clientY - this.firstClientY;
    
        // Vertical scrolling does not work when you start swiping horizontally.
        if(Math.abs(this.clientX) > minValue){ 
            e.preventDefault();
            e.returnValue = false;
            return false;
        }
    }
    onGoTo(dir,e){

        e.preventDefault();

        this.ts.slider.goTo(dir)
    }

    render(){
        return (
            <>
            <a href="#prev" className="slider-custom-control" onClick={e => this.onGoTo('prev',e)}><span className="arrow-2 left"></span></a>
            <a href="#next" className="slider-custom-control" onClick={e =>  this.onGoTo('next',e)}><span className="arrow-2 right"></span></a>
            <TinySlider settings={settings} ref={ts => this.ts = ts}>
                {services.map((service, index) => (
                <div key={index} style={{ position: "relative" }} className="article">
                    <Link to={service.link}>
                        <img className="article-image" src={isWebpSupported() ? service.image_webp : service.image}></img>
                    </Link>

                    <Link to={service.link}>
                        <span className="article-title" dangerouslySetInnerHTML={{__html: service.title}}></span>
                    </Link>

                    <span className="article-description">{ service.description.split(" ").splice(0,21).join(" ") + '...'}<Link className="view-more" to={service.link}><span>view more</span></Link></span>
                    
                </div>
                ))}
            </TinySlider>
            </>
        );
    }

}


export default ArticlesSlider;